import React, { useState, useEffect, memo } from 'react';
import Layout from '../common/Layout';
import PortfolioTabNavigation from './PortfolioTabNavigation';
import PortfolioComposition from './PortfolioComposition';
import PortfolioLensToggle from '../common/PortfolioLensToggle';
import { usePortfolioLens } from '../../contexts/PortfolioLensContext';
import { apiService } from '../../services/api';
import { CompositionData } from '../../types';

const PortfolioPortfolio: React.FC = () => {
  // CC/CSP portfolio lens — scopes the composition analytics to one strategy or all.
  const { lens } = usePortfolioLens();
  const [compositionData, setCompositionData] = useState<CompositionData | null>(null);
  const [compositionLoading, setCompositionLoading] = useState<boolean>(true);

  // COMPOSITION DATA: re-fetched on lens change (independent of period)
  useEffect(() => {
    let cancelled = false;
    const fetchComposition = async () => {
      setCompositionLoading(true);
      try {
        const data = await apiService.getPortfolioComposition(lens);
        if (!cancelled) setCompositionData(data);
      } catch (error) {
        console.error('Error fetching composition data:', error);
      } finally {
        if (!cancelled) setCompositionLoading(false);
      }
    };
    fetchComposition();
    return () => { cancelled = true; };
  }, [lens]);

  return (
    <Layout>
      <div className="app-page-container">
        {/* Tab Navigation */}
        <PortfolioTabNavigation />

        {/* Composition: header with the CC/CSP lens, then the analytics */}
        <div className="pc-top">
          <h2 className="pc-title">Composition</h2>
          <PortfolioLensToggle />
        </div>
        <PortfolioComposition data={compositionData} loading={compositionLoading} />
      </div>
    </Layout>
  );
};

export default memo(PortfolioPortfolio);
